import React from "react";
import "./style.css";
import { Container, Row, Col } from "react-bootstrap";
import {
  experiencetimelinemarco,
  activitytimelinemarco,
  studytimelinemarco,
  worktimelinemarco,
  worktimelinenatalie,
  studytimelinenatalie,
  activitytimelinenatalie,
  experiencetimelinenatalie,
} from "../../content_option";

export const About = () => {
  return (
    <Container className="About-header">
      <Row className="mb-5 mt-3">
        <Col lg="12">
          <h1 className="display-4 mb-4">Über uns</h1>
          <hr className="t_border my-4 ml-0 text-left" />
        </Col>
      </Row>
      <Row>
        <Col lg="8">
          <h3 className="color_sec">Dipl. Ing. Architekt Marco Richard</h3>
        </Col>
      </Row>

      <Row>
        <Col lg="8">
          <div className="service_">
            <h5 className="service__title">Berufspraxis</h5>
            {worktimelinemarco.map((data, i) => {
              return (
                  <p key={i} className="service_desc">{data.date} {data.jobtitle} {data.where}</p>
              );
            })}
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg="8">
          <div className="service_">
            <h5 className="service__title">Studium</h5>
            {activitytimelinemarco.map((data, i) => {
              return (
                  <p key={i} className="service_desc">{data.date} {data.jobtitle} {data.where}</p>
              );
            })}
          </div>
        </Col>
      </Row>

   <Row>
        <Col lg="8">
          <div className="service_">
            <h5 className="service__title">Studiumbegleitende Aktivitäten</h5>
            {studytimelinemarco.map((data, i) => {
              return (
                  <p key={i} className="service_desc">{data.date} {data.jobtitle} {data.where}</p>
              );
            })}
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg="8">
          <div className="service_">
            <h5 className="service__title">Berufsausbildung</h5>
            {experiencetimelinemarco.map((data, i) => {
              return (
                  <p key={i} className="service_desc">{data.date} {data.jobtitle} {data.where}</p>
              );
            })}
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg="8">
          <h3 className="color_sec pt-6">Dipl. Ing. Innenarchitektur Natalie Richard</h3>
        </Col>
      </Row>

      <Row>
        <Col lg="8">
          <div className="service_">
            <h5 className="service__title">Berufspraxis</h5>
            {experiencetimelinenatalie.map((data, i) => {
              return (
                  <p key={i} className="service_desc">{data.date} {data.jobtitle} {data.where}</p>
              );
            })}
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg="8">
          <div className="service_">
            <h5 className="service__title">Studium</h5>
            {studytimelinenatalie.map((data, i) => {
              return (
                  <p key={i} className="service_desc">{data.date} {data.jobtitle} {data.where}</p>
              );
            })}
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg="8">
          <div className="service_">
            <h5 className="service__title">Studiumbegleitende Aktivitäten</h5>
            {activitytimelinenatalie.map((data, i) => {
              return (
                  <p key={i} className="service_desc">{data.date} {data.jobtitle} {data.where}</p>
              );
            })}
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg="8">
          <div className="service_">
            <h5 className="service__title">Berufsausbildungspraxis</h5>
            {worktimelinenatalie.map((data, i) => {
              return (
                  <p key={i} className="service_desc">{data.date} {data.jobtitle} {data.where}</p>
              );
            })}
          </div>
        </Col>
      </Row>

    </Container>
  );
};
